module.exports = __webpack_public_path__ + "static/media/space-rounded.87997b73.svg";